export const movies = [
  {
    id: 'm01',
    title: '星际回响',
    subtitle: 'Echoes of the Stars',
    type: 'movie',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20of%20a%20lone%20astronaut%20facing%20a%20giant%20glowing%20energy%20portal%20among%20stars%2C%20deep%20space%20nebula%2C%20dramatic%20rim%20light%2C%20dark%20background%2C%20epic%20science%20fiction%20mood%2C%20no%20text%2C%20high%20detail&width=600&height=900&seq=banana-poster-01&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    genres: ['科幻', '冒险'],
    rating: 8.7,
    duration: '128分钟',
    director: '陆川野',
    cast: ['陈屿', '林知夏', '周牧之', '苏晚'],
    language: '国语',
    updatedAt: '2024-10-12',
    summary:
      '一支深空探测队在最后一次任务中，意外接收到来自宇宙深处的神秘回响。随着信号的破译，人类文明的起源被重新书写，而队长林知夏必须在天人交战间做出选择。',
    playCount: 3280,
    tags: ['高清', '独家', '本周热播'],
  },
  {
    id: 'm02',
    title: '长安十二辰',
    subtitle: 'Twelve Hours in Chang\'an',
    type: 'tv',
    poster:
      'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20city%20at%20night%20with%20lanterns%20and%20palace%20rooftops%20under%20moonlight%2C%20dramatic%20cinematic%20atmosphere%2C%20elegant%20vertical%20movie%20poster%20style%2C%20warm%20amber%20highlights%20on%20dark%20sky%2C%20no%20text&width=600&height=900&seq=banana-poster-02&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    genres: ['古装', '悬疑'],
    rating: 9.1,
    duration: '全36集',
    director: '顾长风',
    cast: ['霍砚', '柳如烟', '裴寂', '阿史那'],
    language: '国语',
    updatedAt: '2024-10-14',
    summary:
      '上元节前夕，长安城陷入一场足以倾覆王朝的阴谋。不良帅裴寂只有十二个时辰，去阻止那场注定要燃遍全城的浩劫。',
    playCount: 5620,
    tags: ['热播', '高分', '古装大剧'],
  },
  {
    id: 'm03',
    title: '暗夜追凶',
    subtitle: 'Hunt in the Dark',
    type: 'tv',
    poster:
      'https://readdy.ai/api/search-image?query=Moody%20noir%20city%20detective%20silhouette%20under%20rain%20at%20night%2C%20neon%20reflections%20on%20wet%20street%2C%20dark%20cinematic%20crime%20thriller%20poster%2C%20amber%20and%20teal%20tones%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=banana-poster-03&orientation=portrait',
    year: 2023,
    region: '中国大陆',
    genres: ['犯罪', '悬疑'],
    rating: 8.4,
    duration: '全24集',
    director: '韩牧',
    cast: ['周衍', '许清欢', '高铮'],
    language: '国语',
    updatedAt: '2024-09-28',
    summary:
      '一桩尘封十年的旧案重现江湖，刑警周衍在追查真凶的过程中，逐渐发现自己最信任的人也藏着一个无法言说的秘密。',
    playCount: 4120,
    tags: ['烧脑', '悬疑'],
  },
  {
    id: 'm04',
    title: '极速边缘',
    subtitle: 'Edge of Speed',
    type: 'movie',
    poster:
      'https://readdy.ai/api/search-image?query=High%20speed%20sports%20car%20drifting%20on%20a%20racing%20track%20at%20dusk%2C%20motion%20blur%2C%20sparks%2C%20dramatic%20lighting%2C%20cinematic%20action%20movie%20poster%20vertical%20composition%2C%20dark%20background%2C%20no%20text&width=600&height=900&seq=banana-poster-04&orientation=portrait',
    year: 2024,
    region: '美国',
    genres: ['动作', '赛车'],
    rating: 8.0,
    duration: '136分钟',
    director: 'Dean Carter',
    cast: ['Mike Reyes', 'Sofia Lane', 'Andre Cole'],
    language: '英语',
    updatedAt: '2024-10-08',
    summary:
      '退役车手为了拯救即将倒闭的车队，重返那条让他失去一切的赛道。速度与救赎，在这一夜迎来终局。',
    playCount: 2890,
    tags: ['动作', '飙车'],
  },
  {
    id: 'm05',
    title: '深海之约',
    subtitle: 'Promise of the Deep',
    type: 'movie',
    poster:
      'https://readdy.ai/api/search-image?query=Romantic%20cinematic%20poster%20of%20a%20couple%20standing%20on%20a%20misty%20pier%20at%20sunrise%2C%20soft%20warm%20light%2C%20calm%20sea%2C%20melancholic%20mood%2C%20vertical%20composition%2C%20soft%20film%20grain%2C%20no%20text&width=600&height=900&seq=banana-poster-05&orientation=portrait',
    year: 2023,
    region: '韩国',
    genres: ['爱情', '剧情'],
    rating: 7.9,
    duration: '118分钟',
    director: 'Kim Ji-woo',
    cast: ['Lee Eun', 'Park Joon', 'Choi Min'],
    language: '韩语',
    updatedAt: '2024-09-15',
    summary:
      '一个小镇邮差与一位海洋研究员，用二十年时间书写的信，跨越了潮汐与离别，只为赴一场迟到的约定。',
    playCount: 1980,
    tags: ['治愈', '爱情'],
  },
  {
    id: 'm06',
    title: '时空信笺',
    subtitle: 'Letters Across Time',
    type: 'tv',
    poster:
      'https://readdy.ai/api/search-image?query=Dreamy%20fantasy%20poster%20of%20a%20woman%20holding%20a%20glowing%20letter%20surrounded%20by%20floating%20clocks%20and%20light%20particles%2C%20ethereal%20blue%20and%20gold%20light%2C%20magical%20atmosphere%2C%20vertical%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=banana-poster-06&orientation=portrait',
    year: 2024,
    region: '韩国',
    genres: ['奇幻', '爱情'],
    rating: 8.6,
    duration: '全16集',
    director: 'Jung Ha-eun',
    cast: ['Yoon Seo', 'Kang Tae', 'Lim Na'],
    language: '韩语',
    updatedAt: '2024-10-11',
    summary:
      '一只旧邮筒能让信件穿越时空。两个活在相差十年的人，靠着这些信笺，试图改写彼此注定的遗憾。',
    playCount: 3670,
    tags: ['奇幻', '口碑'],
  },
  {
    id: 'm07',
    title: '龙脊传说',
    subtitle: 'Legend of the Dragon Ridge',
    type: 'movie',
    poster:
      'https://readdy.ai/api/search-image?query=Epic%20fantasy%20poster%20of%20a%20giant%20dragon%20circling%20snow%20mountain%20peaks%20at%20dawn%2C%20adventurer%20silhouette%20on%20a%20cliff%2C%20dramatic%20clouds%2C%20cinematic%20lighting%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=banana-poster-07&orientation=portrait',
    year: 2022,
    region: '中国大陆',
    genres: ['奇幻', '冒险'],
    rating: 7.6,
    duration: '142分钟',
    director: '白幕',
    cast: ['云沧', '阮棠', '古啸'],
    language: '国语',
    updatedAt: '2024-08-20',
    summary:
      '传说龙脊之巅沉睡着一头远古巨龙，猎龙人云沧踏上雪山，却发现他要守护的，远比他要猎杀的更加沉重。',
    playCount: 2230,
    tags: ['东方奇幻', '特效'],
  },
  {
    id: 'm08',
    title: '无声证词',
    subtitle: 'Silent Testimony',
    type: 'tv',
    poster:
      'https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20lawyer%20in%20a%20dark%20courtroom%20with%20light%20streaming%20through%20tall%20windows%2C%20tense%20dramatic%20mood%2C%20cinematic%20legal%20thriller%20poster%20vertical%2C%20cool%20tones%2C%20no%20text&width=600&height=900&seq=banana-poster-08&orientation=portrait',
    year: 2023,
    region: '美国',
    genres: ['悬疑', '律政'],
    rating: 8.8,
    duration: '全20集',
    director: 'Alan Pierce',
    cast: ['Grace Doyle', 'Marcus Reid', 'Nina Cho'],
    language: '英语',
    updatedAt: '2024-09-30',
    summary:
      '一名从不败诉的辩护律师，接下一桩人人喊打的案子。当所有证据都指向有罪，他必须找出那个「无声」的真相。',
    playCount: 3050,
    tags: ['律政', '高分'],
  },
  {
    id: 'm09',
    title: '春日便利店',
    subtitle: 'Spring Convenience',
    type: 'tv',
    poster:
      'https://readdy.ai/api/search-image?query=Cozy%20Japanese%20convenience%20store%20during%20cherry%20blossom%20season%2C%20warm%20evening%20light%2C%20blooming%20sakura%2C%20gentle%20nostalgic%20mood%2C%20cinematic%20vertical%20poster%2C%20soft%20pastel%20tones%2C%20no%20text&width=600&height=900&seq=banana-poster-09&orientation=portrait',
    year: 2024,
    region: '日本',
    genres: ['治愈', '日常'],
    rating: 8.9,
    duration: '全12集',
    director: 'Sato Ken',
    cast: ['Aoi Hana', 'Ren Kubo', 'Mika Ito'],
    language: '日语',
    updatedAt: '2024-10-10',
    summary:
      '小镇转角的便利店，收留了每一个深夜来访的人。一个夜班店员的温柔，悄悄治愈着整条街的孤独。',
    playCount: 2760,
    tags: ['治愈系', '慢节奏'],
  },
  {
    id: 'm10',
    title: '幻境代码',
    subtitle: 'Phantom Code',
    type: 'movie',
    poster:
      'https://readdy.ai/api/search-image?query=Futuristic%20holographic%20code%20matrix%20surrounding%20a%20hooded%20figure%20in%20a%20dark%20cyberpunk%20room%2C%20orange%20and%20amber%20glow%2C%20cinematic%20science%20fiction%20thriller%20poster%20vertical%2C%20no%20text&width=600&height=900&seq=banana-poster-10&orientation=portrait',
    year: 2023,
    region: '英国',
    genres: ['科幻', '惊悚'],
    rating: 7.8,
    duration: '124分钟',
    director: 'Oliver Grant',
    cast: ['Ethan Webb', 'Clara Nash'],
    language: '英语',
    updatedAt: '2024-09-05',
    summary:
      '一名程序员发现自己生活的世界竟是一段被反复运行的代码。当他开始修改它，危险也随之而来。',
    playCount: 1740,
    tags: ['赛博', '烧脑'],
  },
  {
    id: 'm11',
    title: '山海食堂',
    subtitle: 'Mountain & Sea Diner',
    type: 'tv',
    poster:
      'https://readdy.ai/api/search-image?query=Warm%20cozy%20Japanese%20izakaya%20restaurant%20interior%20at%20night%20with%20steaming%20dishes%20on%20a%20wooden%20counter%2C%20lantern%20light%2C%20inviting%20atmosphere%2C%20cinematic%20vertical%20poster%2C%20no%20text&width=600&height=900&seq=banana-poster-11&orientation=portrait',
    year: 2022,
    region: '日本',
    genres: ['美食', '剧情'],
    rating: 8.5,
    duration: '全20集',
    director: 'Sato Ken',
    cast: ['Taro Abe', 'Yui Mori', 'Haru Endo'],
    language: '日语',
    updatedAt: '2024-08-12',
    summary:
      '一间只在天黑后开门的小食堂，用一道道家常菜，串起了山里与海边那些平凡却动人的故事。',
    playCount: 2560,
    tags: ['美食', '治愈'],
  },
  {
    id: 'm12',
    title: '破晓行动',
    subtitle: 'Operation Daybreak',
    type: 'movie',
    poster:
      'https://readdy.ai/api/search-image?query=World%20war%20era%20soldiers%20advancing%20at%20dawn%20through%20smoke%20and%20ruins%2C%20dramatic%20golden%20light%20breaking%20through%2C%20cinematic%20war%20movie%20poster%20vertical%2C%20muted%20tones%2C%20no%20text&width=600&height=900&seq=banana-poster-12&orientation=portrait',
    year: 2022,
    region: '中国大陆',
    genres: ['战争', '历史'],
    rating: 8.3,
    duration: '148分钟',
    director: '秦烈',
    cast: ['赵峥', '孙明', '钱远'],
    language: '国语',
    updatedAt: '2024-07-30',
    summary:
      '黎明前的最后一场突围。一支被围困的侦察小队，用血肉之躯为身后的城市争取了宝贵的十二小时。',
    playCount: 3470,
    tags: ['主旋律', '战争史诗'],
  },
  {
    id: 'm13',
    title: '城市之光',
    subtitle: 'City Lights',
    type: 'tv',
    poster:
      'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20blue%20hour%20with%20a%20lone%20figure%20looking%20out%20from%20a%20high%20rise%20window%2C%20reflective%20glass%2C%20urban%20emotional%20drama%20poster%2C%20cinematic%20vertical%2C%20no%20text&width=600&height=900&seq=banana-poster-13&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    genres: ['都市', '情感'],
    rating: 7.7,
    duration: '全30集',
    director: '林一白',
    cast: ['沈舟', '何夕', '蒋澈'],
    language: '国语',
    updatedAt: '2024-10-13',
    summary:
      '金融街上三个年轻人在理想与现实之间挣扎前行。霓虹之下，每一盏灯都藏着一个不肯认输的梦。',
    playCount: 2340,
    tags: ['都市', '职场'],
  },
  {
    id: 'm14',
    title: '月球旅客',
    subtitle: 'Lunar Travelers',
    type: 'movie',
    poster:
      'https://readdy.ai/api/search-image?query=Family%20silhouettes%20standing%20on%20the%20lunar%20surface%20looking%20at%20a%20giant%20earthrise%2C%20starry%20sky%2C%20warm%20hopeful%20mood%2C%20cinematic%20vertical%20science%20fiction%20poster%2C%20no%20text&width=600&height=900&seq=banana-poster-14&orientation=portrait',
    year: 2024,
    region: '美国',
    genres: ['科幻', '家庭'],
    rating: 8.4,
    duration: '120分钟',
    director: 'Dean Carter',
    cast: ['Mike Reyes', 'Emma Stone', 'Leo Park'],
    language: '英语',
    updatedAt: '2024-10-06',
    summary:
      '一趟送物资的月球航班，意外载上了一对父子。跨越三十八万公里的旅程，让他们重新学会了如何说爱。',
    playCount: 2610,
    tags: ['温情', '科幻'],
  },
  {
    id: 'm15',
    title: '江湖再会',
    subtitle: 'Meet Again in Jianghu',
    type: 'tv',
    poster:
      'https://readdy.ai/api/search-image?query=Wuxia%20swordsman%20standing%20on%20a%20bamboo%20forest%20rooftop%20in%20the%20rain%20with%20flowing%20robes%2C%20ink%20painting%20atmosphere%2C%20cinematic%20martial%20arts%20poster%20vertical%2C%20green%20and%20grey%20tones%2C%20no%20text&width=600&height=900&seq=banana-poster-15&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    genres: ['武侠', '古装'],
    rating: 8.7,
    duration: '全40集',
    director: '顾长风',
    cast: ['谢云归', '温七七', '楚天阔'],
    language: '国语',
    updatedAt: '2024-10-15',
    summary:
      '十年前他退隐江湖，十年后故人一封书信，让他不得不重提旧剑。山河未改，人已两鬓风霜。',
    playCount: 4890,
    tags: ['武侠', '口碑'],
  },
  {
    id: 'm16',
    title: '海洋之心',
    subtitle: 'Heart of the Ocean',
    type: 'movie',
    poster:
      'https://readdy.ai/api/search-image?query=Underwater%20scene%20with%20a%20majestic%20whale%20shark%20gliding%20through%20sunbeams%2C%20schools%20of%20fish%2C%20vivid%20ocean%20blue%2C%20nature%20documentary%20poster%20vertical%2C%20cinematic%20light%2C%20no%20text&width=600&height=900&seq=banana-poster-16&orientation=portrait',
    year: 2023,
    region: '英国',
    genres: ['纪录', '自然'],
    rating: 9.0,
    duration: '96分钟',
    director: 'Neil Dawson',
    cast: ['Neil Dawson'],
    language: '英语',
    updatedAt: '2024-09-22',
    summary:
      '历时四年，横跨三大洋。这部纪录片用极致的高清影像，记录了大海深处那些几乎从未被人类见过的生命奇迹。',
    playCount: 3130,
    tags: ['纪录片', '4K高清'],
  },
];

export const heroSlides = [
  {
    id: 'm01',
    image:
      'https://readdy.ai/api/search-image?query=Epic%20cinematic%20science%20fiction%20backdrop%20of%20a%20futuristic%20city%20at%20night%20with%20flying%20vehicles%20and%20glowing%20yellow%20lights%2C%20wide%20panoramic%20composition%2C%20dramatic%20dark%20sky%2C%20blockbuster%20movie%20key%20art%2C%20no%20text&width=1600&height=900&seq=banana-hero-01&orientation=landscape',
    tagline: '年度科幻巨制 · 全网独播',
  },
  {
    id: 'm15',
    image:
      'https://readdy.ai/api/search-image?query=Sweeping%20cinematic%20landscape%20of%20ancient%20Chinese%20mountains%20with%20a%20lone%20temple%20above%20the%20clouds%20at%20sunrise%2C%20golden%20light%2C%20mist%2C%20epic%20wuxia%20film%20backdrop%2C%20no%20text&width=1600&height=900&seq=banana-hero-02&orientation=landscape',
    tagline: '东方武侠美学 · 全新上线',
  },
  {
    id: 'm12',
    image:
      'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20war%20battlefield%20at%20dawn%20with%20golden%20light%20breaking%20through%20smoke%20over%20a%20wide%20open%20plain%2C%20epic%20scale%2C%20blockbuster%20key%20art%2C%20no%20text&width=1600&height=900&seq=banana-hero-03&orientation=landscape',
    tagline: '战争史诗 · 高清重映',
  },
  {
    id: 'm04',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20racing%20backdrop%20on%20a%20neon%20lit%20city%20highway%20at%20night%20with%20light%20trails%20and%20speed%2C%20dynamic%20motion%2C%20blockbuster%20action%20key%20art%2C%20no%20text&width=1600&height=900&seq=banana-hero-04&orientation=landscape',
    tagline: '极速狂飙 · 动作爽片',
  },
];

export const featuredRegions = ['中国大陆', '美国', '韩国', '日本', '英国'];

export const featuredGenres = ['科幻', '悬疑', '爱情', '动作', '古装', '治愈', '武侠', '犯罪'];

export const homeSeo = {
  title: '香蕉视频app - 高清影视视频播放平台',
  description:
    '香蕉视频app为用户提供最新高清影视视频播放服务，包含丰富电影电视剧资源，支持多种播放模式，满足您的观影需求。',
  keywords: '香蕉视频app,影视视频,高清电影,电视剧观看,视频播放平台,热门影视,在线视频',
};